<template>
    <div class="list-turma">

        <c-panel>      
            
            <el-form label-position="top" class="u-mb-30">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" v-if="$store.state.user.tipo > 3 && $store.state.user.tipo <= 8">
                        <el-form-item key="instituicao">
                            <el-select @change="loadingTurmas" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div class="table-turmas container-table" v-if="statusList && Object.keys(items).length > 0">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th></th>
                            <th class="hidden-mobile u-text-center"><b>TURNO</b></th>
                            <th class="u-text-right"><b>SITUAÇÃO / AÇÃO</b></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(cursos, m) in items">
                            <tr :key="m">
                                <td class="titleTurma" colspan="100%">{{ m }}</td>
                            </tr>
                            <template v-for="(turmas, i) in cursos">
                                <tr :key="turmas.id">
                                    <td v-bind:style="{borderTop: (i == 0) ? 'none' : ''}"><span style="margin-left: 30px;"><b>TURMA:</b> {{ turmas.nome }}</span></td>
                                    <td v-bind:style="{borderTop: (i == 0) ? 'none' : ''}" class="hidden-mobile u-text-center">{{ $CONSTANTS.TURNO[turmas.turno] }}</td>
                                    <td v-bind:style="{borderTop: (i == 0) ? 'none' : ''}" class="u-text-right" style="padding-right: 0;">

                                        <el-button type="primary" title="Situação do diário" size="mini" style="width: 232px; cursor: default;">
                                            <span v-if="turmas.fase_diario == 5 && turmas.status_enturmacao_conservados">
                                                CONCLUÍDO
                                            </span>
                                            <span v-if="turmas.fase_diario == 5 && !turmas.status_enturmacao_conservados">
                                                PENDENTE
                                            </span>
                                            <span v-if="turmas.fase_diario != 5">
                                               -
                                            </span>
                                        </el-button> 

                                        <el-button :disabled="turmas.status_enturmacao_conservados" @click="openAlunos(turmas)" :type="turmas.status_enturmacao_conservados ? 'info' : 'primary'" title="Visualizar detalhes" icon="el-icon-search" size="mini"></el-button>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>

            <div v-if="!statusList" class="u-text-center" style="margin-top: 50px; margin-bottom: 50px;">
                <hr>
                    <img class="u-mt-10 u-mb-10" src="/public/img/loading-bar.gif" />
                <hr>
            </div>

            <div v-if="statusList && filtro.instituicao.id && Object.keys(items).length === 0" style="border: 1px solid #ccc; background-color: #efefef;">
                <h4 class="u-text-center">nenhuma turma cadastrada</h4>
            </div>

            <div v-if="statusList && !filtro.instituicao.id && Object.keys(items).length === 0" style="border: 1px solid #ccc; background-color: #efefef;">
                <h4 class="u-text-center">selecione uma instituição</h4>
            </div>

        </c-panel>

    </div>
</template>
<script>

export default {
    data: () => ({
        statusList: true,
        filtro: {
            instituicao: {
                id: '',
                nome: ''
            },
            periodo: {
                id: '',
                nome: ''
            },
        },
        items: {}

    }),
    mounted(){

        this.filtro.periodo.id = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

        if(this.$store.state.config.instituicao){

            this.filtro.instituicao = this.$store.state.config.instituicao;
        }

        this.loadingTurmas();
    },
    methods: {
        
        loadingTurmas(){

            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id || !this.filtro.periodo.id){

                return false;
            }

            let i = this.$store.state.config.instituicao.id;
            let p = this.filtro.periodo.id;

            this.statusList = false;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListTurmas/` + i + '/' + p, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        openAlunos(turma){

            if(turma.fase_diario != 5) {

                this.$alert('O diário desta turma não está encerrado.', 'Atenção', {
                    confirmButtonText: 'OK',
                    type: 'warning'
                }).catch(()=>{});
                
                return;
            }

            this.$router.push(`/admin/turma/situacao-academica/${turma.id}`);  
        }
    },
    components:{  }
}
</script>
<style>

    .table-turmas .table th, .table-turmas .table td {
        padding: 5px 10px;
    }

    .list-turma .list-turno{
        padding-left: 0px;
    }

    .titulo-curso{

        background-color: #e8e8e8;
        margin-top: 25px;
        padding: 5px 20px;
        display: block;
    }

    .list-cursos{
        padding-left: 15px;
    }

    .list-turmas{

        margin-top: 10px;
        display: block;
    }

    .instituicao .container-list-turmas{
        text-transform: uppercase;
    }

    .row-turma{
        border-bottom: 1px solid #ccc;
    }


</style>